module.exports = __webpack_public_path__ + "images/d1a797ffdd66894ed25cb71ac9edbd54.jpg";